// Source: https://usehooks-ts.com/react-hook/use-on-click-outside.
import useEventListener from './use-event-listener.js';
/**
 * Custom hook that handles clicks outside a specified element.
 */
function useOnClickOutside({ ref, handler, context, eventType = 'mousedown', eventListenerOptions = {}, }) {
    useEventListener(eventType, (event) => {
        const target = event.target;
        // Do nothing if the target is not connected to the document.
        if (!target?.isConnected) {
            return;
        }
        const isOutside = Array.isArray(ref)
            ? ref
                .filter((r) => Boolean(r.current))
                .every((r) => r.current && !r.current.contains(target))
            : ref.current && !ref.current.contains(target);
        const contextElements = document.querySelectorAll(`[data-click-outside-context="${context}"]`);
        const isIgnored = Array.from(contextElements).some((contextElement) => contextElement.contains(target));
        if (isOutside && !isIgnored) {
            handler(event);
        }
    }, undefined, eventListenerOptions);
}
export default useOnClickOutside;
